import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Link, Redirect, useLocation } from 'react-router-dom'
import { Layout, Menu } from 'antd'
import {
  WifiOutlined,
  ShopOutlined,
  DeploymentUnitOutlined,
  ProfileOutlined,
  HeartOutlined,
  LogoutOutlined,
  DashboardOutlined,
  LineChartOutlined,
  BarChartOutlined,
  PieChartOutlined,
  UserOutlined,
  FileOutlined,
  MessageOutlined,
  CalendarOutlined,
  FileTextOutlined,
} from '@ant-design/icons'
import { useLocalization } from '@contexts/LocalizationContext'
import { useAuth } from '@contexts/AuthContext'
import imageRewardIcon from '@image/imageRewardicon.png'
import imagePromotion from '@image/Promotion.png'
import BabyAppoveSvg from '@image/icons/BabyAppoveSvg'
import WellKidzClubSvg from '@image/icons/wellKidzClubSvg'

const { Footer, Sider, Content } = Layout
// const { SubMenu } = Menu

const AppLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false)
  const location = useLocation()
  const { t } = useLocalization()
  const { user } = useAuth()

  const onCollapse = (collapsed) => {
    setCollapsed(collapsed)
  }

  if (!user) {
    return <Redirect to="/" />
  }

  const menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: <Link to="/dashboard">{t('menu.dashboard')}</Link>,
    },

    {
      key: '/checklist',
      icon: <ProfileOutlined />,
      label: t('menu.checklist'),
      children: [
        {
          icon: <ShopOutlined />,
          label: <Link to="/vaccines">{t('menu.vaccine')}</Link>,
          key: '/vaccines',
        },
        {
          icon: <HeartOutlined />,
          label: <Link to="/health-check">{t('menu.healthCheck')}</Link>,
          key: '/health-check',
        },
        {
          icon: <DeploymentUnitOutlined />,
          label: <Link to="/development">{t('menu.development')}</Link>,
          key: '/development',
        },
      ],
    },
    {
      key: '/growth',
      icon: <LineChartOutlined />,
      label: t('menu.growth'),
      children: [
        {
          icon: <PieChartOutlined />,
          label: <Link to="/weight">{t('menu.weight')}</Link>,
          key: '/weight',
        },
        {
          icon: <BarChartOutlined />,
          label: <Link to="/height">{t('menu.height')}</Link>,
          key: '/height',
        },
      ],
    },
    {
      key: '/telemedicine',
      icon: <WifiOutlined />,
      label: t('menu.telemedicine'),
      children: [
        // {
        //   icon: <DeploymentUnitOutlined />,
        //   label: <Link to="/specialties">{t('menu.specialty')}</Link>,
        //   key: '/specialties',
        // },
        {
          icon: <ShopOutlined />,
          label: <Link to="/hospitals">{t('menu.hospital')}</Link>,
          key: '/hospitals',
        },
        {
          icon: <MessageOutlined />,
          label: <Link to="/dialog-chat">{t('menu.dialogChat')}</Link>,
          key: '/dialog-chat',
        },
      ],
    },
    {
      key: '/articles',
      icon: <FileOutlined />,
      label: <Link to="/articles">{t('menu.article')}</Link>,
    },

    {
      key: '/blogs',
      icon: <FileTextOutlined />,
      label: <Link to="/blogs">{t('menu.blog')}</Link>,
    },
    {
      key: '/rewards',
      icon: <img src={imageRewardIcon} alt="" width={14} height={14} />,
      label: t('menu.rewards'),
      children: [
        {
          label: <Link to="/rewards-list">{t('menu.rewardsList')}</Link>,
          key: '/rewards-list',
        },
        {
          label: <Link to="/shop">{t('menu.rewardsShop')}</Link>,
          key: '/shop',
        },
        {
          label: (
            <Link to="/special-event">{t('menu.rewardsSpecialEvent')}</Link>
          ),
          key: '/special-event',
        },
        {
          label: <Link to="/collector-coins">{t('menu.rewardsCoins')}</Link>,
          key: '/collector-coins',
        },
      ],
    },
    {
      key: '/promotion',
      icon: <img src={imagePromotion} alt="" width={14} height={14} />,
      label: <Link to="/promotion">{t('menu.promotion')}</Link>,
    },
    {
      key: '/wellkidzclub',
      icon: (
        <div>
          <WellKidzClubSvg width={14} />
        </div>
      ),
      label: t('menu.wellKidClub'),
      children: [
        {
          label: <Link to="/member">{t('menu.member')}</Link>,
          key: '/member',
        },
        {
          label: <Link to="/eCoupon">{t('menu.eCoupon')}</Link>,
          key: '/eCoupon',
        },
        {
          label: <Link to="/privileges">{t('menu.privileges')}</Link>,
          key: '/privileges',
        },
        {
          key: '/campaign',
          label: <Link to="/campaign">{t('menu.campaign')}</Link>,
        },
        {
          label: <Link to="/discount-code">{t('menu.discountCode')}</Link>,
          key: '/discount-code',
        },
      ],
    },
    {
      key: '/activities',
      icon: <CalendarOutlined />,
      label: <Link to="/activities">กิจกรรม</Link>,
    },
    {
      key: '/users',
      icon: <UserOutlined />,
      label: <Link to="/users">{t('menu.user')}</Link>,
    },
    {
      key: '/babyApprove',
      icon: (
        <div>
          <BabyAppoveSvg width={14} />
        </div>
      ),
      label: t('menu.babyApprove'),
      children: [
        {
          label: (
            <Link to="/babyWaitingApprove">{t('menu.babyWaitingApprove')}</Link>
          ),
          key: '/babyWaitingApprove',
        },
        {
          label: <Link to="/babyApproved">{t('menu.babyApproved')}</Link>,
          key: '/babyApproved',
        },
      ],
    },
    {
      key: '/logout',
      icon: <LogoutOutlined />,
      label: <Link to="/logout">{t('menu.logout')}</Link>,
    },
  ]

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
        <h1
          style={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            color: 'white',
            padding: 20,
          }}
        >
          Well Kidz
        </h1>
        <Menu
          theme="dark"
          defaultSelectedKeys={['/dashboard']}
          selectedKeys={[location.pathname]}
          mode="inline"
          items={menuItems}
        />
      </Sider>
      <Layout>
        <Content style={{ backgroundColor: 'white' }}>{children}</Content>
        <Footer style={{ textAlign: 'center' }}>
          ©{new Date().getFullYear()} Well Kidz
        </Footer>
      </Layout>
    </Layout>
  )
}

AppLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export default AppLayout
